var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendericoagentn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2194_19649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4676 6.73343C15.3342 6.86676 16.2009 7.06676 16.8676 7.73343C17.5342 8.46676 17.6676 9.53343 17.7342 10.5334H6.26758C6.33424 9.53343 6.46758 8.46676 7.20091 7.73343C7.80091 7.06676 8.66758 6.86676 9.53425 6.73343V6.13343C9.53425 5.86676 9.66758 5.6001 10.0009 5.6001C10.3342 5.6001 10.5342 5.86676 10.5342 6.13343V6.66676H13.4009V6.13343C13.4009 5.8001 13.6009 5.6001 13.9342 5.6001C14.2676 5.6001 14.4676 5.86676 14.4676 6.13343V6.73343ZM6.26758 11.5334H17.7342V12.6667V13.8667C17.7342 15.0667 17.7342 16.5334 16.8676 17.4C16.0091 18.2585 14.7581 18.332 13.633 18.3981L13.6009 18.4H10.4009C9.26758 18.3334 8.00091 18.2 7.13424 17.4C6.26758 16.4667 6.26758 15 6.26758 13.8667V11.5334Z",
    fill: "#AAACAD"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 6,
    stroke: "#E3E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2194_19649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericoagentn);
export default __webpack_public_path__ + "static/media/calendericoagentn.78245f2e0685d4628a2a4ad6f4c35a1e.svg";
export { ForwardRef as ReactComponent };